<template>
    <div class="card">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fas fa-history mr-2"></i>{{ $t('general.historialdemensajes') }}</h3>
            <div class="card-tools d-flex align-items-center">
                <select class="form-control form-control-sm mr-2" 
                        v-model="tipoMensajeSelec" 
                        name="direccion_mensajes" 
                        style="width: 160px; display: inline-block;">
                    <option value="">Todos</option>
                    <option value="direccion=entrante">Entrantes</option>
                    <option value="direccion=saliente">Salientes</option>
                    <option value="acciones_pendientes=1">Acciones pendientes</option>
                </select>
                <!--<span v-if="ia">
                    <img src="../../../../assets/img/apuyen_ia.png" title="Apuyen IA" alt="Apuyen Logo"
                        class="brand-image" style="height: 40px;">
                    <button type="button" class="btn btn-secondary" title="Generar resumen">
                        <i class="fab fa-creative-commons-nd"></i>
                    </button>
                    <button type="button" class="btn btn-secondary" title="Consulta historial"
                        @click="mostrartaConsulta=true">
                        <i class="far fa-question-circle"></i>
                    </button>
                </span>-->
                <button v-if="ia" type="button" class="btn btn-tool btn-ia-magic mr-1" title="Funcionalidad iA: Generar resumen" @click="cargarResumen()">
                    <i class="fab fa-creative-commons-nd"></i>
                </button>
                <button v-if="ia" type="button" class="btn btn-tool btn-ia-magic mr-1" title="Funcionalidad iA: Consulta historial" @click="mostrartaConsulta=true">
                    <i class="far fa-question-circle"></i>
                </button>
                <!--<button type="button" @click="cambiaraltura()" class="btn btn-tool" title="Pantalla completa" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>-->
                <button type="button" id="botoneye" class="btn btn-tool ampliar-asegurado" data-card-widget="collapse" title="Minimizar"
                    v-on:click="minimizar()">
                    <i class="fas fa-eye"></i>
                </button>
                <button type="button" class="btn btn-tool ampliar-asegurado" title="Ampliar" v-if="columna == 'col-md-6'"
                    v-on:click="altura='100%';ampliar()">
                    <i class="fas fa-plus"></i>
                </button>
                <button type="button" class="btn btn-tool reducir-asegurado" title="Reducir" v-if="columna == 'col-md-12'"
                    v-on:click="altura='550px';reducir()">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
        <Dialog v-model:visible="formulariovisible" modal header="" :style="{ width:'400px' }">
            <div style="display: flex; flex-direction: column; ">
                <div style="align-self: center;" class="form-group" v-for="campo in datosEditando.campos" :key="campo"
                    v-show="!['hora', 'minuto'].includes(campo.nombre.toLowerCase())"> 
                    <label>{{ campo.desc }}</label><br>
                    <Calendar 
                        style="width: 100%;" 
                        dateFormat="dd/mm/yy"
                        v-if="campo.tipo.toLowerCase()=='text' && campo.nombre.toLowerCase() == 'fecha'"
                        v-model="campo.valor" 
                        showTime 
                        hourFormat="24" 
                        :stepMinute="10" />
                    <Dropdown style="width: 100%;"
                        v-else-if="campo.tipo.toLowerCase() == 'select'"
                        v-model="campo.valor" 
                        :options="campo.valores" 
                        optionLabel="texto" 
                        optionValue="valor" 
                        placeholder="Seleccione una opción" />
                    <input v-else type="text" v-model="campo.valor" class="form-control">
                </div>
                <div style="text-align: end;">
                    <button @click="acionarFormulario()" class="btn btn-sm btn-primary">Aceptar</button>
                </div>
            </div>
        </Dialog>
        <div class="card-body">
            <div class="direct-chat-messages" id="historialchat" :style="'height:' + altura ">
                <div v-if="isloading" class="loading-container">
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                </div>
                <div id="resumen" v-show="mostrarResumen">
                    <h3>Resumen:</h3>
                    <p v-html="this.resumen"></p>
                </div>
                <div id="consulta" v-show="mostrarConsulta">
                    <h3>Respuesta consulta:</h3>
                    <p v-html="this.consulta"></p>
                </div>
                <div id="taconsulta" v-show="mostrartaConsulta" style="text-align: end;">
                    <textarea v-model="textoConsulta" style="width: 100%;" id="consulta" rows="3"
                        placeholder="Indica tu consulta"></textarea>
                    <button class="btn btn-sm btn-secondary" style="border: 1px solid grey;"
                        @click="cargarConsulta">Enviar</button>
                </div>
                <div class="direct-chat-msg" v-for="mensaje in mensajesList" :key="mensaje.id_mensaje">
                    <div>
                        <div class="direct-chat-infos clearfix">
                            <span class="direct-chat-name float-left">{{mensaje.usuario_mensaje}}</span>
                            <div class="float-left row" style="margin-left: 50px ;align-items: center; gap: 15px;">
                                <span class="direct-chat-timestamp">{{mensaje.fecha_hora}}</span>
                                <div class="row" v-if="typeof mensaje.acciones === 'object'"
                                    style="align-items: center;">
                                    <label style="margin: 0;" for="">Acciones: </label>
                                    <button @click="acciones(accion, datos, mensaje)" class="btn btn-sm"
                                        v-for="[accion, datos] in Object.entries(mensaje.acciones)"
                                        :title="datos.icono.title" :key="accion"><i :class="datos.icono.class"
                                            :style="datos.icono.style"></i>{{ datos.icono.text }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="direct-chat-img">
                            <div class="row">
                                <div><i :class="mensaje.icono_direccion" :style="mensaje.color_direccion"></i></div>
                                <div><i :class="mensaje.tipo_comunicacion.class" :title="mensaje.tipo_comunicacion.tipo"
                                        :style="mensaje.tipo_comunicacion.style"></i><br></div>
                                <div v-if="mensaje.icono_audio"><i title="Contiene audio"
                                        :class="mensaje.icono_audio"></i></div>
                            </div>
                        </div>
                        <div class="direct-chat-text"
                            :style="'background-color:'+mensaje.color_mensaje.split(':')[1]+';'+difuminado(mensaje)">
                            <div
                                v-if="mensaje.info_mensaje.length < 220 || mensaje.info_mensaje.includes('Error') || mensaje.info_mensaje.includes('ERROR')">
                                <b style="color: red"
                                    v-if="(mensaje.info_mensaje.includes('Error') || mensaje.info_mensaje.includes('ERROR')) && !mensaje.info_mensaje.includes('RECIBIDO EMAIL')"><span
                                        v-html="cambiarmensaje(mensaje.info_mensaje)"></span></b>
                                <span
                                    v-if="(!mensaje.info_mensaje.includes('Error') && !mensaje.info_mensaje.includes('ERROR')) || mensaje.info_mensaje.includes('RECIBIDO EMAIL')"
                                    v-html="cambiarmensaje(mensaje.info_mensaje)"></span>
                            </div>
                            <div v-else-if="mensaje.reducido" style="display: flex; flex-direction: column;">
                                <p style="margin-bottom:0rem" v-html="cambiarmensaje(mensaje.info_mensaje).slice(0, 220) + '...'"></p>
                                <button style="align-self: end; border:1px solid grey" class="btn btn-sm btn-light"
                                    @click="mensaje.reducido = false">Mostrar más</button>
                            </div>
                            <div v-else style="display: flex; flex-direction: column;">
                                <p v-html="cambiarmensaje(mensaje.info_mensaje)"></p>
                                <button style="align-self: end; border:1px solid grey" class="btn btn-sm btn-light"
                                    @click="mensaje.reducido = true">Mostrar menos</button>
                            </div>
                            <p></p>
                            <b v-if="mensaje.documentos && mensaje.documentos.length>0">Documentos del mensaje:</b>
                            <p></p>
                            <a v-for="documento in mensaje.documentos" target="_blank" :key="documento"
                                :href="documento.url_completa_descarga"><i :class="documento.icono"
                                    title="Documento"></i>{{documento.nombre}}</a>
                            <p></p>
                            <audio v-if="mensaje.fichero_audio" controls>
                                <source :src="mensaje.fichero_audio" type="audio/mpeg">
                                Tu navegador no soporta el elemento de audio
                            </audio>
                            <p></p>
                            <button class="btn btn-secondary" v-if="mensaje.transcripcion"
                                @click="mensaje.transcripcionamostrar = mensaje.transcripcion"><i
                                    v-if="mensaje.icono_transcripcion"
                                    :class="mensaje.icono_transcripcion"></i>Transcribir audio</button>
                            <p>{{mensaje.transcripcionamostrar}}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Calendar from 'primevue/calendar';
import { PwgsApi } from '../../../../services/PwgsApi';
export default ({
    props: ['id','mensajes','columna','minimizarprop'],
    emits:[
        'actualiza'
    ],
    data() {
        return {
            mensajesList: [],
            tipoMensajeSelec:'',
            datosEditando:[],
            accionEditando:'',
            formulariovisible: false,
            aux : "direct-chat-text",
            resumen: "",
            consulta:"",
            mostrarResumen: false,
            isloading: false,
            urlapu:'',
            ia:false,
            mostrarConsulta: false,
            mostrartaConsulta: false,
            textoConsulta:"",
            altura: '550px',
            mensajeFormulario:'',
            repetir:0,
        }
    },
    setup() {
        return;
    },
    components: {
        Calendar,
    },
    methods: {
        ampliar() {
            this.$parent.ampliarcolumna();    
        },
        cambiaraltura() {
            if(this.altura == '550px'){
                this.altura = '100%';
            }else{
                this.altura = '550px';
            }
        },
        reducir() {
            this.$parent.reducircolumna();
        },
        cambiarmensaje(mensaje) {
            return mensaje.replaceAll("\u0080", "€");  
        },
        difuminado(mensaje) {
            if (mensaje.acciones && mensaje.acciones["ipas-marcar-leida"]) {
                return "filter: blur(10px);-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;"
            }
            else{
                return " ";
            }
        },
        async acionarFormulario(){
            const api = new PwgsApi();
            var datos = this.datosEditando;
            var accion = this.accionEditando;
            var tipo = datos.tipo_peticion;
            var body = {accion:accion};       
            for(let campo of datos.campos){
                var nombre = campo.nombre;
                var valor = campo.valor;
                if(nombre =='fecha'){
                    const fechaSeleccionada = campo.valor;
                    if(fechaSeleccionada instanceof Date) {
                        body['fecha'] = this.transformarFecha(fechaSeleccionada);
                        body ['hora'] = fechaSeleccionada.getHours();
                        body['minuto'] = fechaSeleccionada.getMinutes();
                    }else{
                        body['fecha'] = this.transformarFecha(valor);
                    }
                    continue;
                }

                if(nombre == 'hora' || nombre == 'minuto') continue;

                body[nombre] = valor;
            }

            if(body.accion == "ipas-guardar-asignacion"){
                if(body.gremio_servicio_mensaje_select != '' && body.gremio_servicio_mensaje_texto != ''){
                    alert('Debe seleccionar un gremio existente o escribir un nuevo gremio, no ambas cosas.')
                    return;
                }
                if(body.gremio_servicio_mensaje_select == '' && body.gremio_servicio_mensaje_texto == ''){
                    alert('Debe seleccionar un gremio existente o escribir un nuevo gremio.');
                    return;
                }
                if(body.gremio_servicio_mensaje_select != ''){
                    body.gremio_servicio_mensaje = body.gremio_servicio_mensaje_select;
                }else{
                    body.gremio_servicio_mensaje = body.gremio_servicio_mensaje_texto;
                }
                delete body.gremio_servicio_mensaje_select;
                delete body.gremio_servicio_mensaje_texto;
            }
            if(tipo.toLowerCase() == 'put'){
                try{
                    await api.put([datos.accion],body)
                }catch(e){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                }finally{
                    this.$toast.add({ severity: 'success', summary: 'Realizado', detail: 'Acción realizada correctamente', life: 2000 });
                }
            }else if(tipo.toLowerCase() == 'post'){
                try{
                    await api.post([datos.accion],body)
                }catch(e){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                }finally{
                    this.$toast.add({ severity: 'success', summary: 'Realizado', detail: 'Acción realizada correctamente', life: 2000 });
                }
            }
            this.$emit('actualizaMensaje', this.mensajeFormulario.id_mensaje);
            this.formulariovisible=false;
        },
        transformarFecha(fechaISO){
            // Convertir la cadena a un objeto Date
            let fecha = new Date(fechaISO);

            // Obtener el día, mes y año
            let dia = String(fecha.getDate()).padStart(2, '0');
            let mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
            let anio = fecha.getFullYear();

            // Formatear la fecha en dd/mm/yyyy
            let fechaFormateada = `${dia}/${mes}/${anio}`;
            return fechaFormateada;
        },

        async cargarConsulta(){
            if(this.textoConsulta == ""){
                alert('Indica tu consulta.')
            }else{
                try{
                    this.mostrartaConsulta=false;
                    this.isloading = true; // Activar el estado de carga
                    const api = new PwgsApi();
                    const res = await api.post("servicios/"+this.id+"/consulta-historial",{"consulta":this.textoConsulta});
                    this.consulta = res.respuesta;
                    if(!this.consulta){
                        this.consulta = "*No hay mensajes disponibles para responder la consulta*";
                    }
                }catch(e){
                    this.consulta = "Error al cargar la consulta.";
                }finally{
                    this.isloading = false; // Desactivar el estado de carga
                    this.mostrarConsulta = true;
                }
            }            
        },
        async cambio(){
            this.resumen="";
            this.mostrarResumen=false;
            this.consulta="";
            this.mostrarConsulta=false;
            this.mostrartaConsulta=false;
            this.textoConsulta="";
        },
        cargarurl() {
            this.urlapu = localStorage.getItem('direccion');
        },
        mostrartranscripcion(idmensaje) {
            document.getElementById(idmensaje).style.visibility = "visible";
        },
        cambiaMensaje(mensaje){
            console.log('lelgaact', mensaje, this.mensajesList);
            var mensajeEncontrado = this.mensajesList.find(m => m.id_mensaje == mensaje.id_mensaje);
            var indexof = this.mensajesList.indexOf(mensajeEncontrado);
            console.log('indexof',indexof);
            this.mensajesList[indexof] = mensaje;
        },
        async acciones(accion, datos, mensaje){
            const api = new PwgsApi();
            console.log('accion', accion, datos, mensaje);
            if(accion == 'generali-marcar-favorito'){                
                try{
                    var tipo = datos.tipo_peticion;
                    var valor = datos.campos[0].valor;           
                    if(tipo.toLowerCase() == 'put'){
                        await api.put([datos.accion],{accion:accion, favorito:valor})
                    }else if(tipo.toLowerCase() == 'post'){
                        await api.post([datos.accion],{accion:accion, favorito:valor})
                    }
                    this.$toast.add({ severity: 'success', summary: 'Realizado', detail: 'Acción realizada correctamente', life: 2000 });
                    this.$emit('actualizaMensaje', mensaje.id_mensaje);
                }catch(e){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });

                }
               
            }else{
                var tipo2 = datos.tipo_peticion;
                if(datos.campos){
                    for (let campo of datos.campos) {
                        if(campo.nombre.toLowerCase() == 'fecha' && !campo.valor) {
                            campo.valor = this.redondearMinutosHaciaArriba(new Date(), 10);
                        }
                    }
                    this.datosEditando=datos;
                    this.accionEditando = accion;
                    this.formulariovisible = true;
                    this.mensajeFormulario = mensaje;
                }else{
                    try{
                        if(tipo2.toLowerCase() == 'put'){
                           await api.put([datos.accion],{accion:accion})
                        }else if(tipo2.toLowerCase() == 'post'){
                           await api.post([datos.accion],{accion:accion})
                        }
                        this.$toast.add({ severity: 'success', summary: 'Realizado', detail: 'Acción realizada correctamente', life: 2000 });
                        this.$emit('actualizaMensaje', mensaje.id_mensaje);
                    }catch(e){
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });

                    }
                }
            }              
        },
        redondearMinutosHaciaArriba(fecha, step = 10) {
            const minutos = fecha.getMinutes();
            const resto = minutos % step;
            if (resto !== 0) {
                fecha.setMinutes(minutos + (step - resto));
            }
            return fecha;
        },
        minimizar(){
                this.$parent.$parent.minimizar();
            
        },
        async cargarResumen() {
            this.isloading = true; // Activar el estado de carga
            const api = new PwgsApi();
            try {
                let resumenax = await api.get(`servicios/${this.id}/resumen-historial`);
                this.resumen = resumenax.resumen;
                if (!this.resumen) {
                    this.resumen = "*No hay mensajes disponibles para realizar el resumen*";
                }
            } catch (error) {
                console.error("Error al cargar el resumen:", error);
                this.resumen = "Error al cargar el resumen.";
            } finally {
                this.isloading = false; // Desactivar el estado de carga
                this.mostrarResumen = true;
            }
        },
        async comprobarIa(){
            const api = new PwgsApi();
            const ia = await api.get('parametros-pwgs/inteligencia_artificial');
            if(ia['inteligencia_artificial']==1){
                this.ia=true;
            }
        }
    },
   
    mounted() { 
        this.cargarurl();
        this.comprobarIa();
    },
    watch: {
        id() {
            this.cambio();
        },
        tipoMensajeSelec(value){
            this.$emit('recargarMensajes', value);
        },
        mensajes(){
            this.mensajesList = this.mensajes;
        },
        minimizarprop(){
            if(this.repetir==0){
            document.getElementById("botoneye").click();
                this.repetir = 1;
            }
            setTimeout(() => {
                this.repetir=0;
            }, 500);

        }
    }
})


</script>
<style>
.direct-chat-text{
    border: 0;
    margin: -3px 0 0 50px !important;
}
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}
.direct-chat-text::after,.direct-chat-text::before{
    border-right-color:none;
}

</style>